import React, { FC } from "react";
import Button, { ButtonProps } from "../Button";

const DashedButton: FC<ButtonProps> = ({ sx, ...props }) => {
  return (
    <Button
      sx={{
        border: "1px dashed",
        borderColor: "primary.main",
        fontSize: 15,
        py: 2.5,
        fontWeight: 500,
        ...sx,
      }}
      {...props}
    />
  );
};

export default DashedButton;
